import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import store from '@/state/store';

const staticData = (isXls = false) => {
  store.state.companySettings;
  const shouldHideCpa = utils.checkOcultarCpa();

  let columns = [
    {
      key: 'name',
      label: i18n.t('Name'),
      custom_class: 'text-left'
    },
    {
      key: 'sub_brand_name',
      label: i18n.t('Sub Brand'),
      custom_class: 'text-left'
    },
    {
      key: 'token',
      label: i18n.t('Token'),
      custom_class: 'text-center'
    },
    {
      key: 'active_customers_count',
      label: i18n.t('Users') + ` (${i18n.t('Active')})`,
      custom_class: 'text-center'
    },
    {
      key: 'registered_customers_count',
      label: i18n.t('Users') + ` (${i18n.t('Registers')})`,
      custom_class: 'text-center'
    },
    {
      key: 'ftd_count',
      label: i18n.t('FTD'),
      custom_class: 'text-center'
    },
    {
      key: 'turnover',
      label: i18n.t('Turnover'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'payout',
      label: i18n.t('Prêmio'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'bonus',
      label: i18n.t('Bônus'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'ggr',
      label: i18n.t('GGR'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'admin_fee',
      label: i18n.t('Taxa Admin.'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'net',
      label: i18n.t('Líquido'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    },
    {
      key: 'reward_accumulative',
      label: i18n.t('Comissão'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-right'
    }
  ];

  if (!shouldHideCpa) {
    columns.push(
      {
        key: 'reward_mark_count',
        label: i18n.t('Qtd CPA'),
        custom_class: 'text-center'
      },
      {
        key: 'reward_mark',
        label: i18n.t('CPA'),
        formatter: utils.formatMoneyFloat,
        custom_class: 'text-right'
      }
    );
  }

  columns.push({
    key: 'reward_total',
    label: i18n.t('Total'),
    formatter: utils.formatMoneyFloat,
    custom_class: 'text-right'
  });

  if (isXls) {
    columns.push({
      key: 'bets_turnover',
      label: i18n.t('Bets_Turnover'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'bets_payout',
      label: i18n.t('Bets_Payout'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'bets_bonus',
      label: i18n.t('Bets_Bonus'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'bets_reward',
      label: i18n.t('Bets_Reward'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'bets_admin_fee',
      label: i18n.t('Bets_Admin_Fee'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'games_turnover',
      label: i18n.t('Games_Turnover'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'games_payout',
      label: i18n.t('Games_Payout'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'games_bonus',
      label: i18n.t('Games_Bonus'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'games_reward',
      label: i18n.t('Games_Reward'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'games_admin_fee',
      label: i18n.t('Games_Admin_Fee'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'lotto_turnover',
      label: i18n.t('Lotto_Turnover'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'lotto_payout',
      label: i18n.t('Lotto_Payout'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'lotto_bonus',
      label: i18n.t('Lotto_Bonus'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'lotto_reward',
      label: i18n.t('Lotto_Reward'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
    columns.push({
      key: 'lotto_admin_fee',
      label: i18n.t('Lotto_Admin_Fee'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    });
  }

  return {
    columns: columns
  };
};

export default staticData;
